import React, { memo } from "react";
import "./card.css";

const Card = memo(
  ({ apiName, imageUrl, backgroundColor, apiNameStyles, borderColor }) => {
    return (
      <div
        className="card-container-footer"
        style={{ background: backgroundColor }}
      >
        <div className="card-headings-footer" style={apiNameStyles}>
          {apiName}
        </div>
        <div
          className="card-image-section-footer"
          style={{ borderColor: borderColor }}
        >
          <img src={imageUrl} alt="" loading="lazy" decoding="async" />
        </div>
      </div>
    );
  }
);

export default Card;
